import React from 'react';
import { Icon } from './Icon.js';
export const IconShapeSquareFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("rect", { x: ".5", y: ".5", width: "11", height: "11", rx: "2.75", ry: "2.75", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconShapeSquareFill12.js.map